import { useState } from 'react';

const faqList = [
  {
    q: 'Что такое управленческие переговоры?',
    a: 'Управленческие переговоры — это рабочий инструмент руководителя для достижения договорённостей с сотрудниками, коллегами, собственниками и вышестоящим руководством. Это не только разговоры о зарплате или должности, а любое взаимодействие, где нужно согласовать сроки, ответственность, результат, ресурсы или изменение поведения. Руководитель ведёт переговоры постоянно: при постановке задач, обсуждении KPI, разрешении конфликтов и внедрении изменений.',
  },
  {
    q: 'Чем управленческие переговоры отличаются от обычных переговоров?',
    a: 'Обычные переговоры — чаще разовые сделки с клиентами или партнёрами, где стороны могут разойтись после сделки. Управленческие переговоры встроены в долгосрочные рабочие отношения: руководитель и сотрудник продолжают работать вместе. Поэтому здесь важнее не «победить» в разговоре, а сохранить ответственность, мотивацию и способность сотрудника работать дальше, одновременно добившись выполнения договорённостей.',
  },
  {
    q: 'В каких ситуациях руководителю нужны переговорные навыки?',
    a: 'Практически в ежедневной работе: при постановке задач и согласовании сроков, при обсуждении результатов и KPI, при распределении ответственности и ресурсов, при невыполнении договорённостей, при работе со сложными сотрудниками, при разрешении конфликтов, при внедрении изменений и при обсуждении непопулярных решений. Везде, где нужен не приказ, а принятая договорённость.',
  },
  {
    q: 'Как руководителю договариваться с сотрудниками?',
    a: 'Начинать с подготовки: определить цель разговора, интересы сторон и желаемый результат. Затем ясно сформулировать позицию и ожидания, говорить о конкретных фактах, а не обобщениях, задавать вопросы и слушать ответы. Важно отделять позицию сотрудника от его реального интереса и переводить разговор в конкретные договорённости: действия, сроки и критерии результата.',
  },
  {
    q: 'Как вести переговоры с конфликтным сотрудником?',
    a: 'Сохранять рабочую позицию и не переходить на личности, говорить о конкретном поведении и его последствиях, а не о характере человека. Выяснять, что стоит за сопротивлением — реальное несогласие, непонимание задачи или попытка избежать ответственности. Удерживать фокус на задаче и результате, не позволяя перевести разговор в эмоциональный спор, и фиксировать договорённости.',
  },
  {
    q: 'Как добиться выполнения договорённостей?',
    a: 'Ключ — конкретность и контроль. Договорённость должна включать конкретное действие, срок и критерий результата, а не общие обещания «исправиться». Важно, чтобы стороны одинаково понимали, о чём договорились. Затем руководитель проверяет выполнение в контрольной точке. Если договорённость нарушается, нужно возвращаться к ответственности сотрудника, а не молча переделывать за него.',
  },
  {
    q: 'Как руководителю вести жёсткие переговоры?',
    a: 'Жёсткость руководителя — это не агрессия и не давление должностью, а способность сохранять позицию, границы и ответственность за результат. Это умение спокойно обозначить последствия невыполнения договорённостей, не поддаваться на манипуляции и эмоциональное давление, не отказываться от важных требований и доводить разговор до конкретного решения.',
  },
  {
    q: 'Можно ли научиться управленческим переговорам на тренинге?',
    a: 'Да, переговорные навыки — это практический навык, который отрабатывается. На тренинге участники не просто слушают теорию, а тренируются на реальных управленческих ситуациях: ролевые переговоры, разбор кейсов, анализ собственных формулировок и отработка удержания позиции. Обучение строится вокруг практики, а не лекций.',
  },
  {
    q: 'Сколько длится обучение?',
    a: 'Корпоративный тренинг обычно занимает 1–2 дня практической работы. Модульная программа может длиться несколько недель с практикой между модулями, а комплексная управленческая программа — несколько месяцев. Точный формат и продолжительность определяются после диагностики задач компании.',
  },
  {
    q: 'Можно ли адаптировать программу под компанию?',
    a: 'Да, адаптация — обязательный этап. Сначала мы разбираемся, с какими переговорными ситуациями реально сталкиваются руководители компании: сложные сотрудники, конфликты между отделами, переговоры с руководством. После этого программа настраивается под уровень участников и специфику бизнеса, а реальные кейсы встраиваются в отработку.',
  },
  {
    q: 'Подходит ли программа для новых руководителей?',
    a: 'Да. Новые руководители часто впервые сталкиваются с необходимостью договариваться с бывшими коллегами, проводить сложные разговоры и удерживать управленческую позицию без опоры на личный авторитет. Программа даёт базовые переговорные инструменты и практическую отработку, которая помогает быстрее освоить новую роль.',
  },
  {
    q: 'Можно ли добавить сопровождение после тренинга?',
    a: 'Да. После обучения при необходимости проводится сопровождение: разбираются реальные переговоры и сложные ситуации, возникшие в работе руководителей, корректируются действия и закрепляются навыки. При системной работе определяется, изменилось ли управленческое поведение и качество взаимодействия.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Часто задаваемые вопросы
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы об управленческих переговорах
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4 text-sm md:text-base">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}